export class BadgeTypeConstants {
  // Constants for 'type' column on organisation_badge table
  public static readonly BADGE_TYPE_BADGE = "Badge";

  public static readonly BADGE_TYPE_CERTIFICATION = "Certification";
}
